export { default } from "./CharacterForm";
